import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Table, Button } from 'semantic-ui-react';

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #FFFFFF;
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1100px;

  margin: 6% auto;
`;

export const Title = styled.h1`
  width: 100%;
  margin:0px 0px 15px 0px;
  padding: 0px;

  color:#000000;

  font-size:28px;
  font-family:sans-serif;
  font-weight:600;

  border-bottom: 1px solid rgba(34,36,38,.15);

  display: inline-block;
`;

export const ContainerInputSearch = styled.div`
  width: 100%;
  height: 50px;
  
  & i{
    height: 75% !important;
  }
`;

export const Input = styled.input`
  width:100%;
  height:35px;
  margin:0;
  padding: .67857143em 1em;
  outline:0;
  background:#FFFFFF;
  color:rgba(0,0,0,.87);
  font-size:13px;
  font-family:sans-serif;
  font-weight:400;
  border:1px solid rgba(34,36,38,.15);
  border-radius:4px;
  -webkit-appearance:none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease;
`;

export const CreateButton = styled(Link)`
  width: 100px;
  height: 35px;

  margin-left: 3px;

  color: #000000;
  background: #e0e1e2;

  border-radius: 5px;

  font-family: sans-serif;
  font-size: 16px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover{
    background: #cacbcd;
    font-weight: 700;
    color: #000000;
  }
`;

export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 14;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }
  }

  tfoot{
    a{
      color: #000000 !important;

      i{
        color: #000000 !important;
      }
    }
  }
`;

export const LinkRedirect = styled(Link)`
  color: #2185d0 !important;
  cursor: default;

  &:hover{
    text-decoration: none;
    color: #2d8cd4 !important;
  }
`;

export const SemanticButton = styled(Button)`
  /* background: none !important; */
  border: none;
  i {
    color: #9999;
    :hover {
      color: ${props => (props.info === "delete" ? "red" : "#2185d0")};
    }
  }

  transition: all 0.6s;
`;
